import React from 'react';
import { Path } from 'react-native-svg';

import { IconBase, IconProps } from './IconBase';
import { SVG_PATH_TOAST_INFO_CIRCLE_WITH_I } from './svgPaths';

export const IconToastInfo: React.FunctionComponent<IconProps> = (props) => (
  <IconBase viewBox="0 0 12 12" {...props}>
    <Path d={SVG_PATH_TOAST_INFO_CIRCLE_WITH_I} fill="currentColor" />
  </IconBase>
);
